import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import proposalsActions from '@/redux/proposals/actions';
import { dateToString } from '@/utils/common';

import { Loader } from '@/components';
import { ProposalTypeChoices } from '@/constants/Proposals';

const AsyncProposals = Loadable({
  loader: () => import('./Proposals'),
  loading: Loader,
});

const mapStateToProps = ({ proposals }) => ({
  ...proposals,
  tableProposalsData: proposals.data.map((proposal) => {
    return Object.assign(
      {},
      {
        key: proposal.id,
        id: proposal.id,
        lead: proposal.lead,
        name: proposal.installation_name,
        date_generated: dateToString(proposal.date_generated),
        address: proposal.address,
        proposal_type: ProposalTypeChoices(proposal.proposal_type),
        ppa_rate: proposal.proposal_data?.assumptions?.ppa_rate ?? 'N/A',
        ppa_escalator: proposal.proposal_data?.assumptions?.ppa_escalator ?? 'N/A',
        year_25_savings: proposal.proposal_data?.system_savings_?.year_25_cumulative_savings ?? 'N/A',
      }
    );
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchProposals: proposalsActions.fetchProposals,
      tableChange: proposalsActions.tableChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncProposals);
